import(/* webpackMode: "eager" */ "/app/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Banner/FrontBannerRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/ApplicationsBlogDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/BlogArticle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Blogs/BlogContactCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Social/FollowUs.tsx");
